import { useMemo } from 'react';
import { useSelector } from 'react-redux';

// Types
import { RootState } from 'types/RootState.types';

// Config
import { getRouterLocationPathname } from '../../redux/reducers/router/routerSelector';
import { isDeliveryPage, isPaymentPage } from '../../utils/helpers/pageType';

// Components
import Delivery from '../delivery/Delivery';
import Payment from '../payment/Payment';

const SinglePageSwitch = () => {
  const {
    pathname,
    editBasketModalBaseRoutePath,
    leaveCheckoutModalBaseRoutePath,
  } = useSelector((state: RootState) => ({
    pathname: getRouterLocationPathname(state),
    editBasketModalBaseRoutePath: state.delivery?.editBasketModalBaseRoutePath || '',
    leaveCheckoutModalBaseRoutePath: state.app?.leaveCheckoutModalBaseRoutePath || '',
  }));

  const pageComponent = useMemo(() => {
    if (isDeliveryPage({ pathname, editBasketModalBaseRoutePath, leaveCheckoutModalBaseRoutePath })) {
      return <Delivery />;
    }
    if (isPaymentPage({ pathname, editBasketModalBaseRoutePath, leaveCheckoutModalBaseRoutePath })) {
      return <Payment />;
    }
    return null;
  }, [pathname, editBasketModalBaseRoutePath, leaveCheckoutModalBaseRoutePath]);

  return pageComponent;
};

export default SinglePageSwitch;
